"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { CreateWaveDropsRequiredMetadata } from "@/types/waves.types";
import CreateWaveDropsMetadataRow from "./CreateWaveDropsMetadataRow";
import CreateWaveDropsMetadataAddRowButton from "./CreateWaveDropsMetadataAddRowButton";
import { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
export default function CreateWaveDropsMetadata(t0) {
  const $ = _c(42);
  const {
    requiredMetadata,
    errors,
    onRequiredMetadataChange
  } = t0;
  let t1;
  if ($[0] !== onRequiredMetadataChange || $[1] !== requiredMetadata) {
    t1 = t2 => {
      const {
        index,
        key,
        type
      } = t2;
      const newItems = [...requiredMetadata];
      newItems[index] = {
        key,
        type
      };
      onRequiredMetadataChange(newItems);
    };
    $[0] = onRequiredMetadataChange;
    $[1] = requiredMetadata;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onItemChange = t1;
  let t2;
  if ($[3] !== onRequiredMetadataChange || $[4] !== requiredMetadata) {
    t2 = () => {
      onRequiredMetadataChange([...requiredMetadata, {
        key: "",
        type: ApiWaveMetadataType.String
      }]);
    };
    $[3] = onRequiredMetadataChange;
    $[4] = requiredMetadata;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onAddNewRow = t2;
  let t3;
  if ($[6] !== onRequiredMetadataChange || $[7] !== requiredMetadata) {
    t3 = index_0 => {
      const newItems_0 = [...requiredMetadata];
      newItems_0.splice(index_0, 1);
      onRequiredMetadataChange(newItems_0);
    };
    $[6] = onRequiredMetadataChange;
    $[7] = requiredMetadata;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onRemoveRow = t3;
  let t4;
  if ($[9] !== errors) {
    t4 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.DROPS_REQUIRED_METADATA_NON_UNIQUE);
    $[9] = errors;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const haveNonUniqueMetadata = t4;
  let t5;
  if ($[11] !== requiredMetadata) {
    t5 = () => {
      const keys = requiredMetadata.map(_temp);
      const keyOccurrences = keys.reduce(_temp2, {} as Record<string, number[]>);
      const nonUniqueIndices = [];
      Object.values(keyOccurrences).forEach(indices => {
        if (indices.length > 1) {
          nonUniqueIndices.push(...indices);
        }
      });
      return nonUniqueIndices;
    };
    $[11] = requiredMetadata;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const getNonUniqueMetadataIdxs = t5;
  let t6;
  if ($[13] !== getNonUniqueMetadataIdxs) {
    t6 = getNonUniqueMetadataIdxs();
    $[13] = getNonUniqueMetadataIdxs;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const [nonUniqueMetadataIdxs, setNonUniqueMetadataIdxs] = useState(t6);
  let t7;
  if ($[15] !== getNonUniqueMetadataIdxs) {
    t7 = () => setNonUniqueMetadataIdxs(getNonUniqueMetadataIdxs());
    $[15] = getNonUniqueMetadataIdxs;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== requiredMetadata) {
    t8 = [requiredMetadata];
    $[17] = requiredMetadata;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  useEffect(t7, t8);
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="tw-mb-0 tw-text-lg  sm:tw-text-xl tw-font-semibold tw-text-iron-50">Required metadata</p>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== haveNonUniqueMetadata || $[21] !== nonUniqueMetadataIdxs || $[22] !== onItemChange || $[23] !== onRemoveRow || $[24] !== requiredMetadata) {
    let t11;
    if ($[26] !== haveNonUniqueMetadata || $[27] !== nonUniqueMetadataIdxs || $[28] !== onItemChange || $[29] !== onRemoveRow) {
      t11 = (item_0, i) => <CreateWaveDropsMetadataRow key={`create-wave-drops-metadata-row-${i}`} item={item_0} index={i} isNotUnique={nonUniqueMetadataIdxs.includes(i) && haveNonUniqueMetadata} onItemChange={onItemChange} onItemRemove={onRemoveRow} />;
      $[26] = haveNonUniqueMetadata;
      $[27] = nonUniqueMetadataIdxs;
      $[28] = onItemChange;
      $[29] = onRemoveRow;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    t10 = requiredMetadata.map(t11);
    $[20] = haveNonUniqueMetadata;
    $[21] = nonUniqueMetadataIdxs;
    $[22] = onItemChange;
    $[23] = onRemoveRow;
    $[24] = requiredMetadata;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[31] !== requiredMetadata.length) {
    t11 = requiredMetadata.length === 0 && <div className="tw-text-iron-400 tw-text-sm tw-font-medium tw-py-2 tw-italic">No required metadata added</div>;
    $[31] = requiredMetadata.length;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== onAddNewRow || $[37] !== requiredMetadata.length) {
    t13 = <CreateWaveDropsMetadataAddRowButton itemsCount={requiredMetadata.length} onAddNewRow={onAddNewRow} />;
    $[36] = onAddNewRow;
    $[37] = requiredMetadata.length;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t12 || $[40] !== t13) {
    t14 = <div>{t9}<div className="tw-mt-3 tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-4"><div className="tw-col-span-full tw-flex tw-flex-col tw-gap-y-2">{t12}{t13}</div></div></div>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
}
function _temp2(acc, key_0, index_1) {
  if (!acc[key_0]) {
    acc[key_0] = [];
  }
  acc[key_0].push(index_1);
  return acc;
}
function _temp(item) {
  return item.key;
}